/* eslint-disable */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import '@formatjs/intl-numberformat/polyfill'
import '@formatjs/intl-numberformat/locale-data/en' // locale-data for en
import '@formatjs/intl-numberformat/locale-data/fr' // locale-data for fr

Vue.use(VueI18n);

function loadLocaleMessages() {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([a-z0-9\-_]+)\./i);

        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key)
        }
    });
    return messages;
}
const numberFormats = {
    "en-CA": {
        currency: {
            style: "currency",
            currency: "CAD",
            currencyDisplay: "narrowSymbol",
        },
        currencyDollars: {
            style: 'currency',
            currency: 'CAD',
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        },
        number: {},
        percent2FractionDigits: {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
        percent: {
            style: 'percent',
        },
    },
    "fr-CA": {
        currency: {
            style: "currency",
            currency: "CAD",
            currencyDisplay: "narrowSymbol",
        },
        currencyDollars: {
            style: 'currency',
            currency: 'CAD',
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        },
        number: {},
        percent2FractionDigits: {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
        percent: {
            style: 'percent',
        },
    },
    "en-US": {
      currency: {
        style: "currency",
        currency: "USD",
        currencyDisplay: "narrowSymbol",
      },
      currencyDollars: {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      },
      number: {},
      percent2FractionDigits: {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      percent: {
        style: 'percent',
      },
    },
    "es": {
        currency: {
            style: "currency",
            currency: "USD"
        }
    }
};

export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en_CA',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en_CA',
    messages: loadLocaleMessages(),
    numberFormats
});
